import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

// Simple reusable Markdown -> sanitized HTML pipe
// Usage: <div [innerHTML]="message.content | markdown"></div>
@Pipe({
  name: 'markdown',
  standalone: true,
})
export class MarkdownPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    try {
      // Configure marked (lightweight config)
      marked.setOptions({
        breaks: true,
      });
      const raw = marked.parse(value, { async: false });
      // Sanitize to avoid XSS (links, code, etc.)
      return DOMPurify.sanitize(raw as string, { USE_PROFILES: { html: true } });
    } catch {
      return value; // fallback to raw text on error
    }
  }
}
